import { Action, State, System } from "./types";
import { getInitialStep, getInitialValues } from "./utils";

export function init(values: Partial<State["values"]> = {}): State {
  return {
    message: {
      content: "",
    },
    step: getInitialStep(values),
    values: getInitialValues(values),
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "set-message":
      return {
        ...state,
        message: {
          content: action.message,
          error: !!action.error,
        },
      };
    case "set-step":
      // [TODO] Should be name/view combination be validated?
      return {
        ...state,
        step: {
          name: action.name,
          view: action.view,
        },
      };
    case "set-attestation":
      return {
        ...state,
        values: {
          ...state.values,
          attestation: action.attestation,
        },
      };
    case "set-date":
      return {
        ...state,
        values: {
          ...state.values,
          date: action.date,
        },
      };
    case "set-justification":
      return {
        ...state,
        values: {
          ...state.values,
          justification: action.justification,
        },
      };
    case "add-system":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.concat(action.system),
        },
      };
    case "add-system-access":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.map((system) =>
            system === action.system
              ? {
                  ...system,
                  accesses: system.accesses.concat(action.access),
                }
              : system
          ),
        },
      };
    case "update-system-access":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.map((system) =>
            system === action.system
              ? {
                  ...system,
                  accesses: system.accesses.map((access) =>
                    access === action.access
                      ? { ...access, ...action.data }
                      : access
                  ),
                }
              : system
          ),
        },
      };
    case "remove-system-access":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.reduce(
            (systems: System[], system) =>
              system === action.system
                ? action.system.accesses.length > 1
                  ? systems.concat({
                      ...system,
                      accesses: system.accesses.filter(
                        (access) => access !== action.access
                      ),
                    })
                  : systems
                : systems.concat(system),
            []
          ),
        },
      };
    case "remove-system":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.filter(
            (system) => system !== action.system
          ),
        },
      };
    case "reset-systems":
      return {
        ...state,
        values: {
          ...state.values,
          systems: [],
        },
      };
    case "set-systems":
      return {
        ...state,
        values: {
          ...state.values,
          systems: action.systems,
        },
      };
    case "set-system-accesses":
      return {
        ...state,
        values: {
          ...state.values,
          systems: state.values.systems.map((system) =>
            system === action.system
              ? {
                  ...system,
                  accesses: action.accesses,
                }
              : system
          ),
        },
      };
    case "set-type":
      return {
        ...state,
        values: {
          ...state.values,
          type: action.value,
          revoke_type: action.value === "revoke" ? "unnecessary" : undefined,
        },
      };
    case "set-revoke-type":
      return {
        ...state,
        values: {
          ...state.values,
          revoke_type: action.value,
        },
      };
    case "add-user":
      return {
        ...state,
        values: {
          ...state.values,
          users: state.values.users.concat(action.user),
        },
      };
    case "update-user":
      return {
        ...state,
        values: {
          ...state.values,
          users: state.values.users.map((user) =>
            user.email === action.email ? { ...user, ...action.user } : user
          ),
        },
      };
    case "remove-user":
      return {
        ...state,
        values: {
          ...state.values,
          users: state.values.users.filter(
            (user) => user.email !== action.email
          ),
        },
      };
    case "reset-users":
      return {
        ...state,
        values: {
          ...state.values,
          users: [],
        },
      };
    case "set-users":
      return {
        ...state,
        values: {
          ...state.values,
          users: action.users,
        },
      };
    case "set-target":
      return {
        ...state,
        values: {
          ...state.values,
          target: action.value,
        },
      };
    case "reset":
      return init(action.values);
    default:
      return state;
  }
}
